import HotelPageMailAnalyticsService from './HotelPageMailAnalyticsService';

const hotelPageMailAnalyticsService = new HotelPageMailAnalyticsService();
export default hotelPageMailAnalyticsService;
